<template>
  <div id="comp-menu" class="ios">
    <div class="menu-wrapper">
      <div class="profile">
        <div class="profile-photo">
          <comp-profile
            :userInitial="getUserName.split('')[0]"
            :profileImage="getProfileImage"
          />
        </div>
        <div class="profile-info">
          <div class="user-id">{{ getUserName }}</div>
          <div class="user-email">{{ getUserEmail }}</div>
          <router-link to="/profile/edit" class="edit-profile">
            {{ $t("myMenu.editProfile") }} <i class="fas fa-pencil-alt"></i>
          </router-link>
        </div>
      </div>
      <div class="menu-container">
        <a @click="checkCntBeforeGo('/report')">{{ $t("myMenu.myReport") }}</a>
        <a @click="checkCntBeforeGo('/role')">{{ $t("myMenu.myRole") }}</a>
        <div class="other-container">
          {{ $t("myMenu.language") }}
          <form-select
            :inputStyle="styleSmall"
            :optionAlign="textAlign"
            :optionDatas="optionDatas"
            @selectParent="
              value => {
                setLang(value);
              }
            "
            :selected="this.$store.getters.getLanguage"
          />
        </div>
        <div v-for="(group, key) in ccGroup" :key="key">
          <a @click="toggleExpansion(key)">{{ group.name }}</a>
          <ul v-show="isExpanded(key)">
            <div v-for="(item, index) in group.item" :key="index">
              <div class="sub-menu" @click="performCustomerCenter(index)">
                {{ item }}
              </div>
            </div>
          </ul>
        </div>
        <div class="btn" v-if="getUserEmail" @click="logoutClicked">
          {{ $t("myMenu.logout") }}
        </div>
        <div class="other-container">
          Version
          <div class="info">{{ getAppVersion }}</div>
        </div>
      </div>
      <div class="comment" :is="transForm"></div>
    </div>
    <div class="overlay">
      <div class="btn-close"><i class="fas fa-times"></i></div>
    </div>

    <div class="close-area" v-on:click="isShowMenu(false)"></div>

    <comp-modal
      v-if="showModal"
      @cancel="showModal = !showModal"
      @confirm="modalAction"
      buttonTwo
      titleShow
    >
      <h3 slot="header">{{ modalTitle }}</h3>
      <p slot="body">{{ modalBody }}</p>
    </comp-modal>

    <comp-modal
      v-if="goTestModal"
      @cancel="goTestModal = !goTestModal"
      @confirm="goTest"
      buttonTwo
      titleShow
    >
      <h3 slot="header">{{ $t("myMenu.modalHeader") }}</h3>
      <p slot="body" v-html="$t('myMenu.modalBody')"></p>
    </comp-modal>
  </div>
</template>

<script>
/* global FB */
/* global Kakao */

import CompProfile from '@/components/CompProfile';
import FormButton from '@/components/FormButton';
import FormSelect from '@/components/FormSelect';
import CompModal from '@/components/CompModal';
import common from '@/utils/common';
import LOGIN_TYPE from '@/constants/loginType';
import TEST from '@/constants/test';
import RESPONSE from '@/constants/response';
import SOCIAL from '@/constants/social';
import { loadFbSdk } from '@/utils/social';

export default {
  name: 'comp-menu',
  mixins: [common],
  data() {
    return {
      userName: '',

      // 언어설정 부분 셀렉트 박스 옵션
      styleSmall: 'small',
      textAlign: 'rtl',
      optionDatas: [
        { title: '한국어', value: 'kr' },
        { title: 'English', value: 'en' },
      ],
      langSelected: '',

      ccGroup: {
        item: {
          name: this.$i18n.t('myMenu.customerCenter'),
          open: false,
          item: [
            this.$i18n.t('myMenu.notice'),
            this.$i18n.t('myMenu.faq'),
            this.$i18n.t('myMenu.contactUs'),
          ],
        },
      },
      expandedGroup: [],

      showModal: false,
      modalTitle: '',
      modalBody: '',
      doLogout: false,
      goTestModal: false,
    };
  },
  components: {
    FormSelect,
    FormButton,
    CompProfile,
    CompModal,
  },
  methods: {
    isExpanded(key) {
      return this.expandedGroup.indexOf(key) !== -1;
    },
    toggleExpansion(key) {
      if (this.isExpanded(key)) {
        this.expandedGroup.splice(this.expandedGroup.indexOf(key), 1);
      } else {
        this.expandedGroup.push(key);
      }
    },
    logoutClicked() {
      this.doLogout = true;

      this.modalTitle = this.$i18n.t('myMenu.logout');
      this.modalBody = this.$i18n.t('myMenu.logoutBody');
      this.showModal = true;
    },
    modalAction() {
      this.showModal = false;
      if (this.doLogout) {
        this.logout();
      }
    },
    logout() {
      const loginType = this.$store.getters.getLoginType;

      switch (loginType) {
        case LOGIN_TYPE.NONE:
        case LOGIN_TYPE.EMAIL:
          this.performLogout();
          break;
        case LOGIN_TYPE.FACEBOOK:
          this.performFacebookLogout();
          break;
        case LOGIN_TYPE.KAKAO:
          try {
            Kakao.Auth.logout();
            this.performLogout();
          } catch (e) {
            if (typeof Kakao.Auth === 'undefined') {
              Kakao.init(SOCIAL.KAKAO_CLIENT_ID);
              this.logout();
            }
          }
          break;
        case LOGIN_TYPE.NAVER:
          this.$store.dispatch('naverDisconnect').then(() => {
            this.performLogout();
          });
          break;
        default:
          this.performLogout();
      }
    },
    performFacebookLogout() {
      try {
        FB.getLoginStatus((response) => {
          const status = response.status;
          if (status === 'connected') {
            FB.api('/me/permissions', 'delete', (res) => {
              if (Object.prototype.hasOwnProperty.call(res, 'success')) {
                const result = res.success;
                if (result === true) {
                  this.performLogout();
                } else {
                  this.doLogout = false;

                  this.modalTitle = this.$i18n.t('error.title');
                  this.modalBody = 'Facebook logout failed.';
                  this.showModal = true;
                }
              } else {
                this.doLogout = false;

                this.modalTitle = this.$i18n.t('error.title');
                this.modalBody = 'Facebook logout failed.';
                this.showModal = true;
              }
            });
          } else {
            this.performLogout();
          }
        });
      } catch (exception) {
        if (exception instanceof ReferenceError) {
          loadFbSdk(
            SOCIAL.FACEBOOK_APP_ID,
            SOCIAL.FACEBOOK_API_VERSION,
          ).then(() => this.performFacebookLogout());
        }
      }
    },
    performLogout() {
      this.$store.dispatch('logOut').then(() => {
        localStorage.removeItem('shareUserSeqId');
        localStorage.removeItem('addUserSeqId');

        this.goAccLogin();
      });
    },
    checkCntBeforeGo(path) {
      let qCnt = this.$store.getters.getQCnt;
      if (qCnt || qCnt === 0) {
        this.goReport(qCnt, path);
      } else {
        this.$store.dispatch('getQuestion').then((result) => {
          if (result && result.data) {
            qCnt = result.data.data.qanum;
          } else if (result.error.resultCode === RESPONSE.NO_QUESTION.CODE) {
            qCnt = TEST.MAXIMUM;
          }

          this.$store.dispatch('setQCnt', { qCnt }).then(() => {
            this.goReport(qCnt, path);
          });
        });
      }
    },
    goReport(qCnt, path) {
      if (qCnt < TEST.MAXIMUM) {
        this.goTestModal = true;
      } else {
        this.goPage(path);
      }
    },
    goTest() {
      this.goTestModal = false;
      this.isShowMenu(false);
      this.goPage('/test/question');
    },
    performCustomerCenter(index) {
      if (index === 0) {
        this.goPage('/notice/list/notice');
      } else if (index === 1) {
        this.goPage('/notice/list/faq');
      } else if (index === 2) {
        window.open('mailto:svtn@brainosi.com', 'emailWindow');
      }
    },
  },
  computed: {
    getUserName() {
      const userName = this.$store.getters.getUserName;
      if (userName) {
        return userName;
      }
      return this.$i18n.t('myMenu.anonymous');
    },
    getUserEmail() {
      let email = this.$store.getters.getUserEmail;
      if (email) {
        if (email.length > 22) {
          email = email.slice(0, 22);
          email += '...';
        }
        return email;
      }
      return '';
    },
    transForm() {
      return {
        template: this.$i18n.t('myMenu.terms'),
      };
    },
    getProfileImage() {
      return this.$store.getters.getProfileImage;
    },
    getAppVersion() {
      return '1.0.0';
    },
  },
};
</script>

<style lang="scss" src="../scss/comp-menu.scss" scoped></style>



// WEBPACK FOOTER //
// src/components/CompMenu.vue